"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.offset = function (element) {
    var rect = element.getBoundingClientRect();
    var offsetCompat = window.pageXOffset !== undefined;
    var css1 = ((document.compatMode || '') === 'CSS1Compat');
    var y = offsetCompat ? window.pageYOffset : css1 ? document.documentElement.scrollTop : document.body.scrollTop;
    var x = offsetCompat ? window.pageXOffset : css1 ? document.documentElement.scrollLeft : document.body.scrollLeft;
    return {
        top: rect.top + y,
        left: rect.left + x
    };
};
